import { useSigners } from './useSigners'
import { PublishedStatus, usePublishedStatus } from './usePublishedStatus'

export const useSignedOutsideOfSequence = (): boolean => {
  const publishedStatus = usePublishedStatus()
  const { pendingSigners } = useSigners()

  return Boolean(
    [PublishedStatus.Accepted, PublishedStatus.Executed].includes(
      publishedStatus
    ) && pendingSigners.length
  )
}
